export const testimonials = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    role: 'Director',
    company: 'TechNova Pvt Ltd',
    avatar: 'RK',
    rating: 5,
    text: 'Finegal Tech Solution handled our company registration and GST setup seamlessly. Their team is knowledgeable, prompt, and professional. Highly recommended for any startup looking for end-to-end compliance support.',
  },
  {
    id: 2,
    name: 'Priya Sharma',
    role: 'Founder',
    company: 'GreenLeaf Foods',
    avatar: 'PS',
    rating: 5,
    text: 'Got our FSSAI license and MSME registration done within days. The team guided us through every step. The process was transparent and stress-free. Best compliance consultancy we\'ve worked with.',
  },
  {
    id: 3,
    name: 'Anil Mehta',
    role: 'Managing Partner',
    company: 'AM Trading LLP',
    avatar: 'AM',
    rating: 5,
    text: 'Their trademark registration service was exceptional. They filed our application quickly and handled the objection professionally. Our brand is now fully protected thanks to their IP team.',
  },
  {
    id: 4,
    name: 'Sunita Patel',
    role: 'CFO',
    company: 'Horizon Enterprises',
    avatar: 'SP',
    rating: 5,
    text: 'We outsourced our entire accounting and GST compliance to Finegal. The accuracy, timeliness, and cost savings have been remarkable. It\'s like having a CA firm in-house without the overhead.',
  },
  {
    id: 5,
    name: 'Vikram Singh',
    role: 'CEO',
    company: 'BuildRight Construction',
    avatar: 'VS',
    rating: 5,
    text: 'Annual ROC filings, director KYC, and company compliance — all handled by Finegal without us having to worry about deadlines. Their proactive approach is what sets them apart.',
  },
  {
    id: 6,
    name: 'Nisha Agarwal',
    role: 'Trustee',
    company: 'Aashirwad Foundation',
    avatar: 'NA',
    rating: 5,
    text: 'They helped us register our NGO and set up all compliance processes from scratch. The team\'s understanding of Section 8 and trust laws is excellent. Very grateful for their support.',
  },
];

export const faqs = [
  {
    q: 'How long does company registration take?',
    a: 'Private Limited Company registration typically takes 7-10 working days after submission of all required documents. LLP and OPC registrations take similar timeframes.',
  },
  {
    q: 'What documents are needed for GST registration?',
    a: 'You need PAN card, Aadhaar, business address proof, bank account details, and business photographs. For companies, additional MCA documents are required.',
  },
  {
    q: 'Do you provide post-registration compliance support?',
    a: 'Yes, we provide ongoing compliance support including GST filing, income tax filing, ROC filings, and all statutory requirements after registration.',
  },
  {
    q: 'Can you handle trademark registration for multiple classes?',
    a: 'Absolutely. We handle trademark registrations across all 45 classes and provide end-to-end support from filing to registration certificate.',
  },
  {
    q: 'What is your fee structure?',
    a: 'Our fees are transparent and competitive. We provide a detailed quote upfront after understanding your requirements. Contact us for a free consultation.',
  },
  {
    q: 'How do I get started?',
    a: 'Simply reach out via our contact form or WhatsApp. Our team will schedule a free consultation to understand your needs and guide you accordingly.',
  },
  {
    q: 'Do you serve clients across India?',
    a: 'Yes, we serve clients pan-India. All our services can be availed remotely with digital document submission and virtual consultations.',
  },
  {
    q: 'Can you help with tax planning for my business?',
    a: 'Yes, our expert finance team provides strategic tax planning services to legally minimize your tax liability while ensuring full compliance.',
  },
];

export const stats = [
  { value: '5000+', label: 'Clients Served' },
  { value: '10+', label: 'Years Experience' },
  { value: '50+', label: 'Expert Professionals' },
  { value: '99%', label: 'Client Satisfaction' },
];

export const industries = [
  { name: 'Startups', icon: '🚀' },
  { name: 'SMEs', icon: '🏢' },
  { name: 'Enterprises', icon: '🏛️' },
  { name: 'E-Commerce', icon: '🛒' },
  { name: 'Retail', icon: '🏪' },
  { name: 'Manufacturing', icon: '🏭' },
  { name: 'Healthcare', icon: '🏥' },
  { name: 'Education', icon: '🎓' },
  { name: 'NGOs & Trusts', icon: '🤝' },
  { name: 'Consultants', icon: '💼' },
  { name: 'Service Businesses', icon: '⚙️' },
  { name: 'Export & Trading', icon: '🌏' },
];

export const processSteps = [
  { step: '01', title: 'Free Consultation', description: 'Share your requirements with our experts for a free assessment and guidance.' },
  { step: '02', title: 'Document Collection', description: 'We provide a clear checklist of documents and collect them securely.' },
  { step: '03', title: 'Processing & Filing', description: 'Our experts process and file your application with relevant authorities.' },
  { step: '04', title: 'Updates & Tracking', description: 'Regular status updates until your application is approved.' },
  { step: '05', title: 'Certificate Delivery', description: 'We deliver your certificates and guide you on next compliance steps.' },
];

export const whyChooseUs = [
  { title: 'Expert Team', description: 'Finance Experts, CS, Legal Experts, and Technology professionals under one roof.', icon: '👥' },
  { title: 'Transparent Pricing', description: 'Clear, upfront pricing with no hidden charges or surprise fees.', icon: '💰' },
  { title: 'Fast Turnaround', description: 'Quick processing with dedicated tracking for every assignment.', icon: '⚡' },
  { title: 'Pan-India Service', description: 'Serving clients across all states with remote and in-person support.', icon: '🗺️' },
  { title: 'End-to-End Support', description: 'From registration to ongoing compliance — we handle everything.', icon: '🔄' },
  { title: 'Proven Track Record', description: '5000+ clients served with 99% satisfaction rate over 10 years.', icon: '🏆' },
];

export const coreValues = [
  { title: 'Integrity', description: 'We operate with complete transparency and ethical standards in every engagement.' },
  { title: 'Excellence', description: 'We strive for the highest quality in every service we deliver.' },
  { title: 'Innovation', description: 'We leverage technology to make compliance easier and faster.' },
  { title: 'Client-First', description: 'Your success is our mission. Every decision is made with your best interest.' },
  { title: 'Reliability', description: 'Dependable service delivery with consistent quality and on-time execution.' },
  { title: 'Expertise', description: 'Deep domain knowledge across finance, legal, tax, and technology.' },
];

export const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Services', path: '/services' },
  { label: 'Industries', path: '/industries' },
  { label: 'Blog', path: '/blogs' },
  { label: 'Contact', path: '/contact' },
];

export const contactInfo = {
  email: 'finegaltechsolution@gmail.com',
  phone: '+91 97184 31522',
  whatsapp: '919718431522',
  address: 'Flat No 102, First Floor, F-103 Vishwas Park, Uttam Nagar, New Delhi - 110059',
  hours: 'Mon–Sat: 9:00 AM – 7:00 PM',
};

export const socialLinks = [
  { name: 'LinkedIn', url: 'https://linkedin.com', icon: 'FaLinkedin' },
  { name: 'Twitter', url: 'https://twitter.com', icon: 'FaTwitter' },
  { name: 'Facebook', url: 'https://facebook.com', icon: 'FaFacebook' },
  { name: 'Instagram', url: 'https://instagram.com', icon: 'FaInstagram' },
  { name: 'YouTube', url: 'https://youtube.com', icon: 'FaYoutube' },
];
